<template>
  <div class="text-container">
    <div class="title">ix cam プライバシーポリシー</div>
    <div class="text">
      当社のプライバシー ポリシーは 2024 年 5 月 16 日に更新され、2024 年 5 月 17 日に発効します。 当社は、すべての ix cam 製品およびサービス、および個別のプライバシー ポリシーを除き、現時点で提供される特定の ix cam 製品またはサービスを使用する際にお客様が開示する個人情報の管理方法に関するプライバシーの詳細を提供するために、プライバシー ポリシーを改訂しました。
    </div>
    <div class="text">
      時間をかけて当社のプライバシー慣行に精通し、ご不明な点がございましたらお知らせください。
    </div>
    <div class="title">私たちはあなたに約束します</div>
    <div class="text">
      このプライバシーポリシーは、広州Qiangui Wulian Technology Co.、Ltd。およびその関連会社（以下「ix cam」といいます）を規定しています。 「または「私たち」）ix camを通じて当社の製品およびサービスの使用を収集、使用、開示、処理、および保護する方法 ix cam APPから提供された情報。当社の製品およびサービスを使用する際に本人確認のために特定の情報の提供をお願いする場合、当社はこのプライバシーポリシーおよび/またはユーザー利用規約に厳密に従ってこの情報を使用します。
    </div>
    <div class="text">
      このプライバシーポリシーは、お客様のニーズを念頭に置いて作成されています。当社の個人データの収集と使用方法を完全に理解し、最終的に当社に提供されるすべての個人情報を管理することが重要です。
    </div>
    <div class="text">
      このプライバシーポリシーでは、「個人情報」とは、特定の個人に関する情報を通じて、または当社がアクセスできるその個人に関する他の情報と組み合わせて、特定の個人を直接的または間接的に識別できるすべてのデータを指します。このような個人情報には、お客様が提供またはアップロードする情報、およびデバイス情報が含まれますが、これらに限定されません。
    </div>
    <div class="text">
      当社の製品およびサービスを使用するか、その他の方法で使用法を遵守することにより、お客様は、定期的に行う変更を含め、このプライバシーポリシーに記載されているすべての条件を読み、同意したことを表明します。地域のデータ保護法（欧州連合の包括的なデータ保護規則など）を含む使用法を遵守するために、特定のカテゴリの個人データ（自動化された個人の意思決定など）の処理についてお客様の明示的な同意を求めます。さらに、当社は、お客様の地域のデータ保護法を含む適用法に従って、お客様の個人情報のプライバシー、機密性、およびセキュリティを保護することをお約束します。同時に、私たちはすべての従業員と代理人がこれらの義務を確実に果たすように努めています。
    </div>
    <div class="text">
      結局のところ、私たちが望んでいるのは、ユーザーに最高のエクスペリエンスを提供することです。このプライバシーポリシーに概説されているデータ処理の慣行について質問がある場合は、FAE @ naxclow.comまでご連絡ください。お客様のニーズに対応し、直接質問にお答えします。
    </div>
    <div class="title">一、どのような情報が収集され、どのように使用されますか？</div>
    <div class="subtitle">（一）お客様が個人情報の収集および使用を当社に許可しなければならない状況</div>
    <div class="text">
      個人情報を収集する目的は、お客様に製品やサービスを提供し、適用される関連法、規制、およびその他の規範的な文書を確実に遵守することです。この情報を提供するかどうかを選択する権利はありますが、ほとんどの場合、提供しないと、対応するサービスを提供したり、質問に回答したりできない場合があります。これらの機能は次のとおりです：
    </div>
    <div class="numtitle">（1） スマート接続</div>
    <div class="text">
      Xスマートホームサービスを提供し、スマートデバイスを安全に接続および管理できるようにするために、Wi-Fi情報、IPアドレス、位置情報、ログインアカウント情報、携帯電話関連情報、およびスマートデバイスを収集する場合があります-関連情報、およびキャッシャーアカウントとスマートデバイスの関連情報。この情報は、スマートデバイスの迅速な接続、接続、近くのデバイスの検出、およびデバイス管理の機能を提供するために使用されます。上記の情報の詳細は次のとおりです：
    </div>
    <div class="text">• ログインアカウント情報：キャッシャーアカウント番号、ニックネーム、アバター情報</div>
    <div class="text">
      • 携帯電話関連情報：ハードウェアデバイスID（ imsi 、 imei 、 meid 、デバイスハードウェアシリアル番号、SIMカードID、OAID、Macアドレス、Android ID）、携帯電話モデル、システムバージョン情報、ソフトウェアインストールリスト、システム言語、モバイル国または地域、アプリストアのバージョン番号、携帯電話、CPU、ディスプレイデバイスの画面サイズと解像度に関する電話設定情報。
    </div>
    <div class="text">
      • スマートデバイスの接続中に収集される情報：接続する必要のあるスマートデバイスの種類に基づいて、次の情報を収集する場合があります：
    </div>
    <div class="text">
      • Wi-Fi経由で接続されたスマートデバイス：Wi-Fi情報（SSID、BSSID、Wi-Fi Macアドレス、Wi-Fiパスワード）、デバイスのMacアドレス、デバイスID。
    </div>
    <div class="text">
      • Bluetooth経由でローカル接続を確立した後、Wi-Fi経由で接続されたスマートデバイス：Wi-Fi情報（SSID、BSSID、Wi-Fi Macアドレス、Wi-Fiパスワード）、デバイスMacアドレス、デバイスBluetoothMacアドレス。
    </div>
    <div class="text">• Bluetooth経由で接続されたスマートデバイス：デバイスのBluetooth Macアドレス、デバイスID。</div>
    <div class="text">• メッセージプッシュを有効にした後: アプリケーションの前面と背面がデバイス識別コードを取得します: IMEI、IDFA、Android ID、MAC、OAID、広告 ID、シリアル番号、IMSI、UAID、ICCID、インストールされたアプリケーション情報または実行中のプロセスを含みます情報。</div>
    <div class="numtitle">（2） デバイス共有</div>
    <div class="text">
      ウォレットアカウント、携帯電話番号、WeChatを通じてスマートデバイスを他の人と共有することをサポートします。共有後、共有者はスマートデバイスを制御することもできます。この機能を利用するために、お客様のアカウントID、お客様から提供された共有アカウントID、および共有デバイス情報（デバイスID、デバイス名、デバイス検証キー、デバイス共有ステータス）を収集し、それを使用してデバイスを提供する場合があります。共有ステータス。他のキャッシャーアカウントのユーザー向けに一般的に制御および使用される機能であり、デバイスリストページに共有ステータスを表示するために使用されます
    </div>
    <div class="numtitle">（3） アプリケーションとインテリジェントハードウェアのアップグレード：</div>
    <div class="text">
      個人情報を収集する目的は、製品を提供すること、および/または最新のXスマートホームサービスを継続して楽しむために、Xスマートホームアプリケーションのバージョン情報と携帯電話モデルを使用してXスマートを提供する場合があります。ホームアプリケーションのアップグレードが提供されます。同時に、接続されたスマートデバイスのリストとバージョン番号情報を収集し、スマートデバイスのアップグレード機能を提供して、サービスの最新バージョン（ファームウェアバージョンを含む）を確実に使用できるようにする場合があります。
    </div>
    <div class="subtitle">
      （二）お客様は、お客様の個人情報の収集および使用を当社に許可するかどうかを選択できます
    </div>
    <div class="text">
      Xスマートホームが提供するスマートデバイスの制御と管理をより楽しむために、以下の追加機能がお客様の個人情報を収集および使用する場合があります。この個人情報をご提供いただけない場合でも、Xスマートホームの基本的なサービスはご利用いただけますが、これらの便利な機能をご利用いただけない場合があります。これらの追加機能は次のとおりです：
    </div>
    <div class="numtitle">（1）動きの検出と識別の管理</div>
    <div class="text">
      Xスマートホームプラットフォームを介して動きの検出と認識をサポートする特定の製品（A9など）を接続している場合は、Xスマートホームがサポートする動きの検出と認識機能を有効にして、より豊かなスマートデバイスエクスペリエンスを得ることができます。動きを認識すると、スマートデバイスにフラグを立ててメッセージをプッシュします。
    </div>
    <div class="text">
      私たちが特定した結果について質問がある場合は、アルゴリズムとモデルの最適化に役立つフィードバックをお寄せください。 この場合、問題に関する未承諾のフィードバックのビデオを収集する場合があります。 フィードバックした動画は、アルゴリズムとモデルを最適化するためにのみ使用され、他の目的には使用されませんのでご安心ください。
    </div>
	<div class="numtitle">（2） スマートデバイスの共有</div>
	<div class="text">
	  ウォレットアカウントとWeChatを介してスマートデバイスを他の人と共有することをサポートします。共有後、共有者はスマートデバイスを制御することもできます。この機能を利用するために、お客様のアカウントID、お客様が提供する共有アカウントID、および共有デバイス情報（デバイスID、デバイス名、デバイス検証キー、デバイス共有ステータス）を収集して、デバイスを提供する場合があります。アカウントの他のユーザーと共有して機能を制御および使用し、デバイスリストページに共有ステータスを表示するために使用されます。
	</div>
	<div class="numtitle">（3） バージョンアップ</div>
	<div class="text">
	  最新のXスマートホームサービスを引き続きご利用いただくために、 XスマートホームAPPバージョン情報と携帯電話モデルを使用してXスマートホームアップグレードサービスを提供する場合があります。同時に、接続されたスマートデバイスのリストとバージョン番号情報を収集し、スマートデバイスのアップグレード機能を提供して、サービスの最新バージョン（ファームウェアバージョンを含む）を確実に使用できるようにする場合があります。
	</div>
    <div class="numtitle">（4） ユーザーフィードバック</div>
    <div class="text">
      送信されたフィードバックの質問、フィードバックログ、および入力した電話番号または電子メールを収集する場合があります。これらの情報は、発生した問題をよりよく理解し、連絡するために使用されます。
    </div>
    <div class="subtitle">（三）Xスマートホームのアクセス許可を呼び出すための手順</div>
    <div class="text">
      さらに、Xスマートホームを使用しているときに、次のデバイス権限がトリガーされる場合があります。お客様の情報をより適切に管理するために、製品使用プロセスで許可を申請する際に許可を使用する目的と、許可を有効にしない場合にサービスの使用に影響を与える可能性があることをお知らせします。 、よくご確認ください。特定の機能を使用する前に、次の権限を許可するかどうかを選択できます。同時に、デバイスのアクセス許可設定ページからいつでも認証ステータスを自分で変更できます。
    </div>
    <div class="text">以下は、参照用の関連関数と呼び出し権限の詳細です。：</div>
    <div class="text">
      1.外部ストレージスペースの読み取りと書き込み（Androidバージョン）：スキャンやユーザーフィードバックなどの機能で、デバイス上の写真やファイルの読み取りと書き込みに使用されます。
    </div>
    <div class="text">
      2.位置情報の許可（Android、iOSバージョン）：近くのWLANリストのスキャン、近くのBluetoothデバイスの検索、スマートシーンでの自動ジオフェンスに使用されます。ユーザーがgpsをサポートしていないデバイスにバインドされている場合は、ケイデンス計算を提供するために使用され、正確な移動距離を記録し、ユーザーの移動トラックやその他の機能を描画します。
    </div>
    <div class="text">
      3.カメラの権限（Android、iOSバージョン）：デバイスのインストール、アカウントのログイン、およびその他の機能のためにQRコードをスキャンするために使用されます。
    </div>
    <div class="text">
      4.マイクの許可（Android、iOSバージョン）：ユーザーがXスマートホームでカメラ、ビデオドアベル、およびその他のデバイスをバインドすると、ビデオインターホン、音声コマンドピックアップ、およびその他の機能に使用されます
    </div>
    <div class="text">
      5.電話の読み取り許可（Android）：クライアント側でローカルにデバイスIDを生成するために使用されます。
    </div>
    <div class="text">
      6.WLAN許可を有効にする（Android、iOSバージョン）：デバイスへの迅速な接続に使用する場合は、デバイス通信のためにデバイスから送信されたWIFIに接続します。
    </div>
    <div class="text">
      7.Bluetooth権限をオンにする（Android、iOSバージョン）：デバイスがすばやく接続されたときにデバイスと通信するためにデバイスから送信されたBluetooth信号を接続するために使用されます。Bluetooth経由で接続されたスマートデバイスの場合、Bluetooth権限もあります通信に必要です。
    </div>
    <div class="text">
      8.携帯電話ソフトウェアのインストールリスト（ Android、iOSバージョン）を取得します。便利で迅速なログインのために携帯電話のサードパーティアカウントを取得するために使用されます。
    </div>
	<div class="text">
	  9.ハードウェアデバイスID（imsi、imei、meid、デバイスハードウェアシリアル番号、SIMカードID、OAID、Macアドレス、Android ID）、携帯電話モデル、システムバージョン情報を取得します。アラートを取得するためのユーザーメッセージプッシュ
	</div>
	<div class="text">
	  10. 携帯電話のセンサー情報（ジャイロセンサー、重力センサー、加速度センサー）の取得：広告、広告帰属、不正行為対策、セキュリティのために利用
	</div>
	<div style="font-weight: bold;">
	  11. フォト アルバムの権限 (Android、iOS バージョン): スキャンやユーザー フィードバックなどの機能でデバイス上の写真やビデオの読み取りと書き込みに使用されます。
	</div>
	<div style="font-weight: bold;">
	  12. クリップボード (Android、iOS 版): クリップボード機能は共有機能を実装するために使用されます。
	</div>
	<div style="font-weight: bold;">
	  13. デバイス情報 (IMSI、IDFV) のデバイス ブランド、オペレーター情報、ネットワーク情報、アプリケーション情報 (アプリケーション名、アプリケーションのバージョン番号) を取得します。ワンクリック ログイン機能に使用されます。
	</div>
    <div class="subtitle">
      （四）以下の場合、個人情報の収集および使用について、お客様の同意は必要ありません。：
    </div>
    <div class="text">
      お客様の名前、電話番号、電子メールアドレス、銀行口座番号、およびIMEI番号を使用して、Guangzhou Yiwu Technology Co.、Ltd。およびそのパートナー（Web、モバイルアプリケーション、クラウド製品およびサービスの提供）を提供する場合があります。製品およびサービスに関連する資料。私たちはあなたの場所のデータ保護法を厳守します（いくつかの法律は個別の明示的な同意を必要とする場合があります）ので、事前の明示的な同意のみを求め、明確な肯定的な行動を通じてあなたの同意を得たことを確認しますあなたの個人情報はあなたの同意またはあなたが異議を表明しないまで使用されません。特定のカテゴリの電子メールを受信したくない場合は、ページの下部にあるリンクをクリックして、電子メールの購読を解除できます。ダイレクトマーケティングのためにお客様の個人情報をビジネスパートナーに渡すことはありません。
    </div>
    <div class="subtitle">私たちはあなたの情報を誰と共有しますか？</div>
    <div class="text">1.国家安全保障および国防安全保障に関連します；</div>
    <div class="text">2.公安、公衆衛生、および主要な公益に関連するもの；</div>
    <div class="text">3.犯罪捜査、起訴、裁判および判決の執行に関連する；</div>
    <div class="text">
      4.個人情報主体または他の個人の生命および財産を保護するため。ただし、個人の同意を得ることが困難な場合；
    </div>
    <div class="text">
      5.収集された個人情報は、個人情報の主題によって一般に開示されます；
    </div>
    <div class="text">
      6.法的なニュースレポート、政府情報の開示、その他のチャネルなど、法的に公開された情報から収集された個人情報；
    </div>
    <div class="text">7.ご要望に応じて契約を締結する必要があります；</div>
    <div class="text">
      8.製品および/またはサービスの障害の発見および処分など、提供される製品および/またはサービスの安全かつ安定した運用を維持するために必要です；
    </div>
    <div class="text">9.合法的なニュース報道に必要；</div>
    <div class="text">
      10.学術研究機関が公益に基づく統計的または学術的研究を行う必要がある場合、および学術研究の結果または説明を外部に提供する場合、結果に含まれる個人情報は匿名化されます；
    </div>
    <div class="text">
      お客様の個人情報はすべて安全なサーバーに保存され、管理された施設で保護されます。私たちはあなたのデータを重要性と機密性に従って分類し、あなたの個人情報の最高レベルのセキュリティを保証します。製品やサービスの提供を支援するためにこの情報にアクセスする従業員およびサードパーティのサービスプロバイダーには、厳格な契約上の守秘義務があり、これらの義務を履行しない場合、懲戒処分または解雇につながることを保証します。同様に、クラウドベースのデータストレージ用の特定のアクセス制御があります。要約すると、不正なアクセスや使用を防ぐために、物理的なセキュリティ対策を含む情報の収集、保存、および処理の慣行を定期的に確認します。
    </div>
    <div class="subtitle">（五）第三者からお客様の個人情報を取得する場合</div>
    <div class="text">
      法律で許可されている場合、第三者からお客様の個人情報を取得する場合があります。
    </div>
    <div class="subtitle">（六）非個人情報</div>
    <div class="text">
      また、ユーザーの操作行動（クリック、ページジャンプ、閲覧時間）。この情報を収集する目的は、当社がお客様に提供するサービスを改善することです。収集される情報の種類と量は、お客様が当社の製品やサービスをどのように使用するかによって異なります。この情報を集約して、当社のWebサイト、製品、およびサービスのどの部分がお客様にとって最も関心のあるものであるかについて、より有用な情報をお客様に提供できるようにします。集約されたデータは、このプライバシーポリシーの目的上、非個人情報と見なされます。非個人情報を個人情報と組み合わせて使用する場合、そのような情報は、組み合わせの期間中、個人情報と見なされます。
    </div>
    <div class="numtitle">二、保持ポリシー</div>
    <div class="text">
      当社は、本プライバシーポリシーに記載されているように、または適用法で義務付けられているように、情報が収集された目的に必要な限り、個人情報を保持します。収集の目的を完了した後、削除またはキャンセルの申請を確認した後、または対応する製品またはサービスの運用を終了した後、当社はそれを保持することを停止し、削除または匿名化します。公益、科学、歴史研究、または統計の目的である場合、さらなるデータ処理が収集の本来の目的に関連していなくても、適用法に従って関連データを保持し続けます。さらに、以下の状況では、関連する法規制に従ってお客様の個人情報を保持する必要があります。
    </div>
	<div class="text">
	  • 中華人民共和国の電子商取引法に従い、お客様の商品およびサービス情報と取引情報は、取引の完了日から3年以上保持されるものとします。
	</div>
    <div class="subtitle">三、あなたの権利</div>
    <div class="numtitle">（一）制御設定</div>
    <div class="text">
      私たちは、プライバシーに関する懸念は人によって異なることを認識しています。したがって、Xスマートホームが個人情報の収集、使用、開示、または処理を制限し、プライバシー設定を制御するために選択できるさまざまな方法の例をいくつか示しました。ロケーションアクセスのオン/オフ、カメラ、携帯電話の保管許可の記録と読み取りおよび書き込み；
    </div>
    <div class="subtitle">
      • Xスマートホームアプリの[マイ設定-個人情報]をクリックして、ニックネーム、アバターなどの個人情報を変更します。；
    </div>
    <div class="text">• キャッシュドロワーアカウントへのログインまたはログアウト</div>
    <div class="text">
      上記の目的での個人情報の使用に以前に同意した場合は、書面で、またはFAE@naxclow.comに連絡することにより、いつでも決定を変更することができます。
    </div>
    <div class="numtitle">（二）お客様の個人情報に対するお客様の権利</div>
    <div class="text">
      該当する国または地域の法律および規制に従い、お客様は、当社が保持するお客様の個人情報へのアクセス、修正、および削除を要求する権利を有します（以下、要求と呼びます）。
    </div>
    <div class="text">
      NAXAアカウントの個人情報に関する詳細は、FAE @ naxclow.comでアクセスおよび変更するか、デバイスからアカウントにログインすることで変更できます。詳細については、私たちに手紙を書くか、FAE @ naxclow.comにアクセスしてお問い合わせください。ほとんどの法律では、個人情報の対象者が特定の要件に準拠するように要求することが義務付けられており、このプライバシーポリシーでは、次の状況を満たすように要求する必要があります。：
    </div>
    <div class="text">
      • 専用のリクエストチャネルを通じて、またお客様の情報を保護するために、お客様のリクエストは書面で行う必要があります（現地の法律で口頭によるリクエストが明示的に認められている場合を除く）。：
    </div>
    <div class="text">
      • 要求者が要求された情報の対象または法的に許可された人物であることを確認するために、私たちがあなたの身元を確認できるように十分な情報を提供します
    </div>
    <div class="text">
      • お客様のリクエストを処理できることを確認するための十分な情報が得られたら、適用されるデータ保護法で要求される時間内にお客様のリクエストに対応します。特に：
    </div>
    <div class="text">
      • お客様の要件と適用法に基づいて、収集および処理したお客様の個人情報の無料記録を提供できます。関連情報を他に要求する場合は、関連する適用法に基づいて、実際の状況料金と組み合わせて提供する場合があります。あなたは管理費のための合理的な料金。
    </div>
    <div class="text">
      • 当社が保有するお客様に関する情報が不正確または不完全であると思われる場合は、使用目的のために個人情報の修正または完成を要求することができます。
    </div>
    <div class="text">
      • 適用される法律および規制によっては、お客様の個人データの削除を要求する権利がある場合があります。私たちはあなたの削除要求を評価し、対応する規制が満たされている場合、それに対処するための技術的手段を含む対応する措置を講じます。お客様または当社が関連情報の削除を支援する場合、適用される法律およびセキュリティ技術により、対応する情報をバックアップシステムからすぐに削除できない場合があります。お客様の個人情報を安全に保管し、それ以上の処理から隔離します。バックアップはクリアすることも匿名にすることもできます。たとえば、中華人民共和国の電子商取引法によれば、商品およびサービスの情報と取引情報は、取引の完了日から3年以上保持する必要があります。
    </div>
    <div class="text">
      • 当社は、実体のない/絡み合った繰り返しの要求、他者のプライバシー権を侵害する要求、非常に非現実的な要求、不釣り合いな技術的作業の要求、および現地法で要求されていない要求、公開された情報の処理を拒否する権利を有します。 、機密保持の条件下で提供される情報。また、前述の不正防止およびセキュリティの目的でデータを合法的に使用することを妨げる可能性があると思われる特定の側面において、データの削除またはアクセスの要求を拒否する場合があります。
    </div>
    <div class="numtitle">（三）同意の撤回</div>
    <div class="text">
      • お客様は、リクエストを送信することにより、当社が所有または管理する個人情報の収集、使用、および/または開示を含む同意を取り消すことができます。使用する特定のサービスに応じて、「マイ」-「ユーザー契約とプライバシーポリシー」を介してアプリ内で行うことができます。または、 FAE @ naxclow.comにアクセスしてお問い合わせください。当社は、お客様のリクエストから15日以内にリクエストを処理し、お客様のリクエストに従って、それ以降はお客様の個人情報を収集、使用、および/または開示しません。
    </div>
    <div class="text">
      • 同意の撤回には、特定の法的影響があることに注意してください。お客様が当社に処理を許可する情報の範囲によっては、お客様が当社の製品またはサービスを楽しむことができなくなる可能性があります。ただし、同意または承認を取り消すという決定は、承認に基づく以前の個人情報の処理には影響しません。
    </div>
    <div class="numtitle">（四）サービスまたはアカウントのキャンセル</div>
    <div class="text">
      特定の製品またはサービスをキャンセルしたい場合は、FAE @ naxclow.comにアクセスしてサービスをキャンセルするようにご連絡ください。アカウントを解約したい場合は、アカウントの全商品・サービスをご利用いただけなくなりますので、ご注意ください。お客様または他者の正当な権利および利益を保護するために、当社は、このWebサイトのさまざまな製品およびサービスの使用に基づいて、キャンセル要求をサポートするかどうかを判断します。
    </div>
    <div class="text">
      PS：「マイ」-「アカウントセキュリティ」-「Xスマートホーム」アプリでアカウントをキャンセルすることで、アカウントキャンセルアプリケーションを開始できます。
    </div>
    <div class="subtitle">四、サードパーティのサービスプロバイダーとの個人情報の共有</div>
    <div class="text">
      このビジネスの一部のサービスはサードパーティのサービスプロバイダーによって提供されるため、当社はお客様の個人情報の一部をサードパーティのサービスプロバイダーに提供する必要があります。 当社がお客様の個人情報をこれらの第三者と共有する場合、お客様の情報の安全性を確保するために暗号化およびその他の手段を使用します。 当社が個人情報を共有する企業および組織に対しては、データセキュリティ環境の合理的なレビューを実施し、厳格なデータ処理契約を締結し、第三者に対してお客様の情報に対して適切な保護措置を講じ、関連する法律および規制を厳格に遵守することを要求します。および規制要件。
    </div>
    <div class="text">
       当社は、ix cam アプリの関連機能を実現し、アプリケーションの安全かつ安定した動作を保証するため、関連目的を達成するために、第三者および関係者が提供するソフトウェア開発キット (SDK) にアクセスすることがあります。 当社は、パートナー様が情報を取得するために使用するソフトウェアツール開発キット（SDK）に対して厳格なセキュリティ監視を実施し、データのセキュリティを保護します。 カタログに接続されている関連する SDK がリストされています。詳細については、「<a target="_blank" style="font-weight:bold;" href="#/sdk/sdk_file">「添付資料 - サードパーティ SDK の説明書」</a>。 サードパーティの SDK および関連当事者は、バージョンのアップグレードやポリシーの調整などにより、データ処理の種類に特定の変更を加える可能性があることに注意してください。公開されている公式の手順を参照してください。
    </div>
    <div class="subtitle">五、ポリシーの更新</div>
    <div class="text">
      このポリシーは、ビジネス モデルの調整や更新に基づいて随時改訂され、かかる改訂は本プライバシー ポリシーの一部を構成します。
    </div>
    <div class="text">
      当社は、お客様の明示的な同意がない限り、このポリシーに基づくお客様の権利を削減することはありません。 本ポリシーの条件変更によりお客様の権利が減少したり、お客様の義務が増加したりする場合（つまり、「重大な変更」が発生した場合）、当社はix cam公式Webサイトで発表し、適切な手段（ポップアッププロンプト、電子メールを含む）を使用します。 、SMS など）は、このポリシーの更新を説明するために適時に通知され、変更が発効する前に、変更を受け入れるかどうかを検討するための合理的な期間がお客様と開発者のために確保されます。
    </div>
    <div class="text">
      ユーザーが更新後の本ポリシーに同意しない場合は、ix camのサービスおよびアプリケーションの使用を停止することができ、ユーザーが更新後の本ポリシーが発効した後もix camのサービスおよびアプリケーションを使用し続ける場合は、ユーザーが更新後の本ポリシーを十分に読んで同意したことを示します。
    </div>
    <div class="subtitle">六、お問い合わせ</div>
    <div class="text">
     このプライバシーポリシーについてコメントや質問がある場合、または個人情報の収集、使用、開示について質問がある場合は、以下のアドレスに連絡するか、FAE @ naxclow.comにアクセスして、「プライバシー」について言及してください。ポリシー」。個人情報に関する権利のご要望、お問い合わせ等に応じて、専門のチームが問題を解決いたします。あなたの質問自体がより実質的な問題を含んでいる場合、私たちはあなたにもっと多くの情報を求めるかもしれません。受け取った回答に満足できない場合は、管轄区域の関連する監督当局に苦情を照会することができます。ご相談いただければ、実際の状況に応じて適用される可能性のある関連する苦情の手段に関する情報を提供します。
    </div>
    <div class="text">
    このプライバシーポリシーについてコメントや質問がある場合、または個人情報の収集、使用、開示について質問がある場合は、「プライバシーポリシー」を参照して、次のアドレスのデータ保護責任者に連絡してください：
    </div>
    <div class="text">
      広州ChainlinkIoT Co.、Ltd。
    </div>
    <div class="text">
    Room 916-918、Huahui International、No.4 Zhudian Circuit、Nansha District、Guangzhou：FAE@naxclow.com
    </div>
    <div class="text">私たちのプライバシーポリシーを理解するために時間を割いていただきありがとうございます！</div>
  </div>
</template>

<script type="text/javascript">
	import { mapState } from "vuex"
	export default {
		data() {
			return {};
		},
		created() {
			
		},
		methods: {},
		computed: {
			...mapState({
				tableData: "tableData"
			})
		}
	};
</script>

<style lang="less" scoped>
	.text-container {
		padding: 0 30px 50px;
		word-break:break-all;
		.title {
			font-size: 30px;
			margin: 15px 0;
			font-weight: 900;
		}

		.subtitle {
			font-size: 25px;
			margin: 10px 0;
			font-weight: 600;
		}

		.numtitle {
			font-size: 20px;
			margin: 10px 0;
			font-weight: 600;
		}
		.SDKTitle{
			  font-size: 20px;
			  margin: 15px 0;
			  text-align: center;
		}
		.headSDK{
			  background: rgb(145, 171, 225);
			  text-align: center;
			  display: flex;
			  // align-items: center;
		}
		.contSDK{
			  text-align: center;
			  display: flex;
		}
		th,td{
			  text-align: center;
			  padding: 3px 1px;
			  flex: 1;
			  display: flex;
			  justify-content: center;
			  align-items: center;
		}
	}
</style>